import { VraagboomAntwoord, VraagboomMultiResultaat, VraagboomTextResultaat } from '@models/vragenboom';
import { Antwoord, Vraag, VariableContent, AntwoordMail, VraagMail } from '@models/claims';
import { VariableHelper } from './variable-helper';

export class TekstMapper {
  public static mapResultaten(vraagboomAntwoord: VraagboomAntwoord<VraagboomTextResultaat>,
    variabeleContent: VariableContent[], vragen: Vraag[]) {
    if (vraagboomAntwoord == null || variabeleContent == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag != null) {
      vraag.id = vraagboomAntwoord.vraag.id;

      // Bij optionele lege vraag niets toevoegen - bugfix alleen spaties ook niet
      if (!vraagboomAntwoord.vraag.verplicht && vraagboomAntwoord.resultaat.value.trim().length === 0) {
        vraag.antwoorden = [];
      } else {
        if (vraagboomAntwoord.antwoorden != null) {
          for (const antwoord of vraagboomAntwoord.antwoorden) {
            vraag.antwoorden.push(new Antwoord({ id: antwoord.id }));
            const variable: string = VariableHelper.extractVariable(antwoord.variabeleWaarde);

            if (vraagboomAntwoord.resultaat != null) {
              variabeleContent.push(new VariableContent(vraagboomAntwoord.vraag.id, antwoord.id, variable,
                vraagboomAntwoord.resultaat.value));
            }
          }
        }
      }

      vragen.push(vraag);
    }
  }
  
  public static mapResultatenMail(vraagboomAntwoord: VraagboomAntwoord<VraagboomTextResultaat>, vragen: VraagMail[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: VraagMail = new VraagMail;

    if (vraagboomAntwoord.vraag != null) {
      vraag.vraagtitel = vraagboomAntwoord.vraag.titel;
    }

    if (vraagboomAntwoord.resultaat?.value != null && vraagboomAntwoord.antwoorden?.length === 1) {
      vraag.antwoorden = [];
      const antwoord: AntwoordMail = new AntwoordMail();
      if (vraagboomAntwoord.resultaat.value.length === 0) {
        if (vraagboomAntwoord.vraag?.antwoorden?.length > 0) {
          antwoord.antwoord = vraagboomAntwoord.vraag.antwoorden[0].standaard_waarde;
        }
      } else {
        antwoord.antwoord = vraagboomAntwoord.resultaat.value;
      }
      vraag.antwoorden.push(antwoord);
    }
    vragen.push(vraag);
  }

  public static mapResultatenMulti(vraagboomAntwoord: VraagboomAntwoord<VraagboomMultiResultaat>, variabeleContent: VariableContent[], vragen: Vraag[]) {
    if (vraagboomAntwoord == null || variabeleContent == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag != null) {
      vraag.id = vraagboomAntwoord.vraag.id;

      // Bij optionele lege vraag niets toevoegen - bugfix alleen spaties ook niet
      if (!vraagboomAntwoord.vraag.verplicht && vraagboomAntwoord.vraag.antwoorden && vraagboomAntwoord.vraag.antwoorden[0].waarde?.trim().length === 0) {
        vraag.antwoorden = [];
      } else {
        vraagboomAntwoord.antwoorden.forEach((antw: Antwoord) => {
          vraag.antwoorden.push(new Antwoord({ id: antw.id }));
          const variable: string = VariableHelper.extractVariable(antw.variabeleWaarde);
          variabeleContent.push(new VariableContent(vraag.id, antw.id, variable, antw.waarde));
        });
      }

      vragen.push(vraag);
    }
  }

  public static mapResultatenMultiMail(vraagboomAntwoord: VraagboomAntwoord<VraagboomMultiResultaat>, vragen: VraagMail[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: VraagMail = new VraagMail;
    if (vraagboomAntwoord.vraag != null) {
      vraag.vraagtitel = vraagboomAntwoord.vraag.titel;
    }

    vraagboomAntwoord.antwoorden.forEach((antw: Antwoord) => {
      const antwoord = new AntwoordMail({
        antwoordtitel: antw.titel,
        antwoord: antw.waarde?.length > 0 ? antw.waarde : antw.standaard_waarde
      });
      vraag.antwoorden.push(antwoord);
    });

    vragen.push(vraag);
  }
}
